import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { Document } from "../../../../../models/Document";
import { AppStateWithData } from "../../../../AppStateWithData";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { ArticleCreationInfo } from "./DocumentCreationInfo";
import { CreateItemAdditionalData, getGroupInfoFromCreation } from "./createCustomInput";

export const createArticleActionTypes = createRequestActionTypes('CREATE_ARTICLE')

export const createArticle = (config: ApiConfig) => (articleCreationInfo: ArticleCreationInfo) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const groupInfo = getGroupInfoFromCreation(articleCreationInfo)

    const thunkParams: RequestThunkParameters<Document, ArticleCreationInfo, CreateItemAdditionalData> = {
        method: 'POST',
        body: articleCreationInfo,
        requestActionTypes: createArticleActionTypes,
        actionAdditionalData: {
            laneId: groupInfo.laneId,
            groupUid: groupInfo.groupUid
        },
        url: `${config.API_URL}/content/create/article`,
        processResultBeforeDispatch: (result: Document) => {
            if(config.createdItemOnLibrary) {
                config.createdItemOnLibrary(result, groupInfo)
            }
            if (config.refreshFeed) {
                config.refreshFeed()
            }
            if (config.updateItem) {
                config.updateItem(result.docId)
              }
            return result
        }
    }

    dispatch<any>(createRequestThunk(thunkParams))
}